import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "clearfix" };
const _hoisted_3 = { class: "card m-0" };
const _hoisted_4 = { class: "card-body p-1" };
const _hoisted_5 = { class: "col-xs-12 col-sm-12 col-md-12 p-0 clearfix" };
const _hoisted_6 = { class: "tile_summary" };
const _hoisted_7 = { class: "tile_summary_count" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("label", null, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-server" }),
    /*#__PURE__*/ _createTextVNode(" ")
], -1 /* HOISTED */);
const _hoisted_9 = { class: "tile_summary_count healthy" };
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("label", null, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-check-circle-o" }, " ")
], -1 /* HOISTED */);
const _hoisted_11 = { class: "d-flex align-items-center tile_summary_count warning" };
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("label", null, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-bell" }),
    /*#__PURE__*/ _createTextVNode(" ")
], -1 /* HOISTED */);
const _hoisted_13 = { class: "ack_nack_status" };
const _hoisted_14 = { class: "w-100 text-end" };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("label", null, "ACK: ", -1 /* HOISTED */);
const _hoisted_16 = { class: "w-100 text-end" };
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("label", null, "NACK: ", -1 /* HOISTED */);
const _hoisted_18 = { class: "d-flex align-items-center tile_summary_count critical" };
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("label", null, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-exclamation-triangle" }),
    /*#__PURE__*/ _createTextVNode(" ")
], -1 /* HOISTED */);
const _hoisted_20 = { class: "ack_nack_status" };
const _hoisted_21 = { class: "w-100 text-end" };
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("label", null, "ACK: ", -1 /* HOISTED */);
const _hoisted_23 = { class: "w-100 text-end" };
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("label", null, "NACK: ", -1 /* HOISTED */);
const _hoisted_25 = { class: "tile_summary_count unknown" };
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("label", null, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-question-circle-o" }),
    /*#__PURE__*/ _createTextVNode(" ")
], -1 /* HOISTED */);
const _hoisted_27 = { class: "data-grid main-status-grid detached overflow-x-auto" };
const _hoisted_28 = { class: "table table-hover bottom0 pw100" };
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("th", { class: "text-center w120" }, "\r\n\t\t\t\t\t\t\tOk\r\n\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("th", { class: "text-center w120" }, "\r\n\t\t\t\t\t\t\tACK\r\n\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_31 = /*#__PURE__*/ _createElementVNode("th", { class: "text-center w120" }, "\r\n\t\t\t\t\t\t\tNACK\r\n\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_32 = { class: "w20 min-width20" };
const _hoisted_33 = {
    class: /*#__PURE__*/ _normalizeClass(['alarm'])
};
const _hoisted_34 = ["onClick"];
const _hoisted_35 = ["onClick"];
const _hoisted_36 = { class: "text-center alarm-count" };
const _hoisted_37 = {
    key: 0,
    class: "text-center alarm-count",
    colspan: "2"
};
const _hoisted_38 = {
    key: 1,
    class: "text-center alarm-count"
};
const _hoisted_39 = {
    key: 0,
    class: "badge critical"
};
const _hoisted_40 = {
    key: 1,
    class: "badge warning"
};
const _hoisted_41 = {
    key: 2,
    class: "text-center alarm-count"
};
const _hoisted_42 = {
    key: 0,
    class: "badge critical"
};
const _hoisted_43 = {
    key: 1,
    class: "badge warning"
};
const _hoisted_44 = {
    key: 3,
    class: "alarm-count"
};
const _hoisted_45 = {
    key: 0,
    class: "badge icon-only unknown"
};
const _hoisted_46 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-question-circle-o unknown" }, null, -1 /* HOISTED */);
const _hoisted_47 = [
    _hoisted_46
];
const _hoisted_48 = {
    key: 1,
    class: "badge icon-only healthy"
};
const _hoisted_49 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-check-circle-o" }, null, -1 /* HOISTED */);
const _hoisted_50 = [
    _hoisted_49
];
const _hoisted_51 = { key: 4 };
const _hoisted_52 = { key: 0 };
const _hoisted_53 = /*#__PURE__*/ _createElementVNode("tr", null, [
    /*#__PURE__*/ _createElementVNode("td", {
        class: "text-center",
        colspan: "7"
    }, [
        /*#__PURE__*/ _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t")
    ])
], -1 /* HOISTED */);
const _hoisted_54 = [
    _hoisted_53
];
const _hoisted_55 = { key: 1 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    const _component_router_link = _resolveComponent("router-link");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    return (_ctx.dataLoaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _hoisted_8,
                                    _createTextVNode(),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.visibleStrings.length), 1 /* TEXT */)
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_9, [
                                    _hoisted_10,
                                    _createTextVNode(),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.getFilteredSystemsHealthy), 1 /* TEXT */)
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_11, [
                                    _hoisted_12,
                                    _createTextVNode(),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.getFilteredSystemsWarning), 1 /* TEXT */),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_13, [
                                        _createElementVNode("div", _hoisted_14, [
                                            _hoisted_15,
                                            _createTextVNode(),
                                            _createElementVNode("span", null, _toDisplayString(_ctx.getFilteredAckWarningAlarms), 1 /* TEXT */)
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_16, [
                                            _hoisted_17,
                                            _createTextVNode(),
                                            _createElementVNode("span", null, _toDisplayString(_ctx.getFilteredNackWarningAlarms), 1 /* TEXT */)
                                        ])
                                    ])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_18, [
                                    _hoisted_19,
                                    _createTextVNode(),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.getFilteredSystemsCritical), 1 /* TEXT */),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_20, [
                                        _createElementVNode("div", _hoisted_21, [
                                            _hoisted_22,
                                            _createTextVNode(),
                                            _createElementVNode("span", null, _toDisplayString(_ctx.getFilteredAckCriticalAlarms), 1 /* TEXT */)
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_23, [
                                            _hoisted_24,
                                            _createTextVNode(),
                                            _createElementVNode("span", null, _toDisplayString(_ctx.getFilteredNackCriticalAlarms), 1 /* TEXT */)
                                        ])
                                    ])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_25, [
                                    _hoisted_26,
                                    _createTextVNode(),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.filteredSystemsUnknown), 1 /* TEXT */)
                                ])
                            ])
                        ])
                    ])
                ])
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_27, [
                _createElementVNode("table", _hoisted_28, [
                    _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                            _createElementVNode("th", null, [
                                _createVNode(_component_SortableColumnComponent, {
                                    sorter: _ctx.sorter,
                                    column: { fieldName: 'StringName', title: 'String' }
                                }, null, 8 /* PROPS */, ["sorter"])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("th", null, [
                                _createVNode(_component_SortableColumnComponent, {
                                    sorter: _ctx.sorter,
                                    column: { fieldName: 'SystemName', title: 'System' }
                                }, null, 8 /* PROPS */, ["sorter"])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("th", null, [
                                _createVNode(_component_SortableColumnComponent, {
                                    sorter: _ctx.sorter,
                                    column: { fieldName: 'SiteName', title: 'Site' }
                                }, null, 8 /* PROPS */, ["sorter"])
                            ]),
                            _createTextVNode(),
                            _hoisted_29,
                            _createTextVNode(),
                            _hoisted_30,
                            _createTextVNode(),
                            _hoisted_31,
                            _createTextVNode(),
                            _createElementVNode("th", _hoisted_32, [
                                _createVNode(_component_SortableColumnComponent, {
                                    sorter: _ctx.sorter,
                                    column: { fieldName: 'NumberOfAlarms', title: '' }
                                }, null, 8 /* PROPS */, ["sorter"])
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleStrings, (system, index) => {
                            return (_openBlock(), _createElementBlock("tr", _hoisted_33, [
                                _createElementVNode("td", null, [
                                    _createElementVNode("span", {
                                        class: "pointer blue",
                                        onClick: ($event) => (_ctx.goToStringSnapshot(system.systemId, system.stringId))
                                    }, _toDisplayString(system.stringName), 9 /* TEXT, PROPS */, _hoisted_34)
                                ]),
                                _createTextVNode(),
                                _createElementVNode("td", null, [
                                    _createElementVNode("span", {
                                        class: "pointer blue",
                                        onClick: ($event) => (_ctx.goToSnapshot(system.systemId))
                                    }, _toDisplayString(system.systemName), 9 /* TEXT, PROPS */, _hoisted_35)
                                ]),
                                _createTextVNode(),
                                _createElementVNode("td", null, _toDisplayString(system.siteName), 1 /* TEXT */),
                                _createTextVNode(),
                                _createElementVNode("td", _hoisted_36, _toDisplayString(system.numberOfHealthyBlocks), 1 /* TEXT */),
                                _createTextVNode(),
                                (!_ctx.hasAlarms(system))
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_37))
                                    : _createCommentVNode("v-if", true),
                                _createTextVNode(),
                                (_ctx.hasAlarms(system))
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_38, [
                                        (system.numberOfCriticalAlarmsAck)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                                _createVNode(_component_router_link, {
                                                    to: { name: 'system-alarms', params: { systemId: system.systemId, alarmSeverity: 'critical', acknowledgeStatus: 1 } }
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(system.numberOfCriticalAlarmsAck), 1 /* TEXT */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (system.numberOfWarningAlarmsAck)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                                _createVNode(_component_router_link, {
                                                    to: { name: 'system-alarms', params: { systemId: system.systemId, alarmSeverity: 'warning', acknowledgeStatus: 1 } }
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(system.numberOfWarningAlarmsAck), 1 /* TEXT */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                _createTextVNode(),
                                (_ctx.hasAlarms(system))
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_41, [
                                        (system.numberOfCriticalAlarmsNack)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                                _createVNode(_component_router_link, {
                                                    to: { name: 'system-alarms', params: { systemId: system.systemId, alarmSeverity: 'critical', acknowledgeStatus: 0 } }
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(system.numberOfCriticalAlarmsNack), 1 /* TEXT */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (system.numberOfWarningAlarmsNack)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                                _createVNode(_component_router_link, {
                                                    to: { name: 'system-alarms', params: { systemId: system.systemId, alarmSeverity: 'warning', acknowledgeStatus: 0 } }
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(system.numberOfWarningAlarmsNack), 1 /* TEXT */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                _createTextVNode(),
                                (!_ctx.hasAlarms(system) || system.isSystemOffline)
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_44, [
                                        (system.isSystemOffline)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_45, _hoisted_47))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_48, _hoisted_50))
                                    ]))
                                    : (_openBlock(), _createElementBlock("td", _hoisted_51))
                            ]));
                        }), 256 /* UNKEYED_FRAGMENT */))
                    ]),
                    _createTextVNode(),
                    (!_ctx.visibleStrings.length)
                        ? (_openBlock(), _createElementBlock("tfoot", _hoisted_52, _hoisted_54))
                        : _createCommentVNode("v-if", true)
                ])
            ])
        ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_55, [
            _createVNode(_component_StatusOverlayComponent, {
                visible: "true",
                message: "Loading..."
            })
        ]));
}
